<div class="user-profile-dialog" cdkFocusRegionstart>
	<div class="column user-profile-information">
		<button
			class="user-profile-dialog-close"
			(click)="dialogRef.close()"
			data-automation-id="nav-profile-info-close-button"
		>
			<span class="close-icon" role="img" [title]="closeMenuText"></span>
		</button>
		<div class="row-left">
			<div class="side-nav-avatar-outer">
				<div class="side-nav-avatar">
					{{ this.userInitials }}
				</div>
			</div>
			<div class="user-profile-information-fields">
				<div class="user-name-container">{{ userName }}</div>
				<div class="user-email-container">{{ email }}</div>
			</div>
		</div>

		<button
			mat-button
			class="secondary-button button-text-small"
			i18n="Label for edit account button @@NavProfileInformation-editAccountButton"
			(click)="onEditAccountClick()"
			data-automation-id="nav-profile-info-edit-account-button"
		>
			Edit Account
		</button>
	</div>

	<div class="user-profile-roles">
		<div class="header-margin" i18n="@@navProfileInformation-Roles">Roles</div>
		<mat-action-list class="select-role-container">
			@if (loadingProfile) {
				<span style="padding-left: 24px" i18n="@@navProfileInformation-loadingRoles">Loading Roles...</span>
			}
			@for (item of userProfile.availableAssignedRoles; track item.id) {
				<button
					style="padding-left: 40px; padding-right: 16px"
					mat-list-item
					(click)="onRoleSelected(item)"
					[attr.data-automation-id]="'select-role-' + item.role?.name + 'button'"
				>
					<div class="row-left inherit-height-container smaller-line-height">
						<mat-icon svgIcon="sl-nav-work" class="user-profile-roles-item"></mat-icon>
						<div class="column">
							<div class="font-medium-blue">{{ item.entityRelationship?.parentEntity?.name }}</div>
							<div class="font-small-gray">{{ item.role?.name }}</div>
						</div>
					</div>
				</button>
			}
		</mat-action-list>
	</div>

	<div class="column user-profile-actions">
		<button
			mat-button
			class="secondary-button button-text-small"
			i18n="Label for sign out button @@NavProfileInformation-signOutButton"
			(click)="onSignOutClicked()"
			data-automation-id="nav-profile-info-sign-out-button"
		>
			Sign out
		</button>
		<mat-divider></mat-divider>
		<app-tos-and-privacy-policy></app-tos-and-privacy-policy>
	</div>
</div>
